var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example-code"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.code)?_c('div',{staticClass:"code",domProps:{"innerHTML":_vm._s(_vm.compiledCode)}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }